import React from 'react';
import { Button, Panel } from '@ftdr/blueprint-components-react';
import REText from '@components/wrappedBDS/REText';
import { getCurrentThemeConfig } from '@app/core/theme-config';

export interface SubmitSuccessProps {
  title: string;
  message: string;
  buttonText: string;
  isButtonVisible: boolean;
  onClick?: any;
}

const SumbitSuccess: React.FC<SubmitSuccessProps> = (props: SubmitSuccessProps) => {
  return (
    <Panel
      rounded={getCurrentThemeConfig()?.contactUsSuccessPanelRounded}
      shadow={getCurrentThemeConfig()?.contactUsSuccessPanelShadow}
      border={getCurrentThemeConfig()?.contactUsPanelBorder}
      className="justify-items-center"
    >
      <div className="px-4 pt-4">
        <REText id="contact-success-title" variant="heading-05">
          {props.title}
        </REText>
      </div>
      <div className="px-4 pt-4">
        <REText id="contact-success-message">{props.message}</REText>
      </div>
      <div className="p-8">
        {props.isButtonVisible && (
          <div className={getCurrentThemeConfig()?.contactUsSuccessButtonDivClassName}>
            <Button
              id="contact-success-button"
              label={props.buttonText}
              variant="outlined"
              shape="rounded"
              onClick={props.onClick}
              width={getCurrentThemeConfig()?.contactUsSuccessButtonWidth}
              className={getCurrentThemeConfig()?.contactUsSuccessButtonClassName}
            />
          </div>
        )}
      </div>
    </Panel>
  );
};

export default SumbitSuccess;
